module.exports = __webpack_public_path__ + "3cd031745cf5a019db484692948ab7dc.MP3";